// extracted by mini-css-extract-plugin
module.exports = {"root":"images_root__VaPTP","image-wrapper":"images_image-wrapper__1LkPw","image":"images_image__Ya87a","icon":"images_icon__oAH1_"};